<article
  class="border-standard-outline-light flex w-full gap-3 rounded-lg border-1 p-4"
  [style.color]="fontColor()"
  [attr.data-testid]="'fellow-traveler-' + travelerId()">
  <span class="material-symbols-rounded text-2xl!" aria-hidden="true">
    person
  </span>
  <form
    class="flex w-full flex-col gap-4"
    [formGroup]="fellowTravelerForm"
    (ngSubmit)="save()">
    @if (fellowTravelerStore.isSalutationEnabled()) {
      <aw-drop-down
        [id]="'fellow-traveler-salutation-' + travelerId()"
        [darkModeLabelColor]="
          corporateDesign().colorAdmixtures.dark_text_disabled
        "
        [options]="salutationOptions() | toTranslatedOption"
        [label]="
          texts()
            | filterTexts
              : ERelationType.newCustomerSalutation
              : EEntityType.generalArea
            | language
        "
        formControlName="salutation" />
    }
    <aw-text-input
      [id]="'fellow-traveler-first-name-' + travelerId()"
      [darkModeLabelColor]="
        corporateDesign().colorAdmixtures.dark_text_disabled
      "
      [label]="
        texts()
          | filterTexts
            : ERelationType.newCustomerFirstName
            : EEntityType.generalArea
          | language
      "
      formControlName="firstName" />
    <aw-text-input
      [id]="'fellow-traveler-last-name-' + travelerId()"
      [darkModeLabelColor]="
        corporateDesign().colorAdmixtures.dark_text_disabled
      "
      [label]="
        texts()
          | filterTexts
            : ERelationType.newCustomerLastName
            : EEntityType.generalArea
          | language
      "
      formControlName="lastName" />
    @if (fellowTravelerStore.isDateOfBirthEnabled()) {
      <aw-date-input
        [id]="'fellow-traveler-date-of-birth-' + travelerId()"
        [darkModeLabelColor]="
          corporateDesign().colorAdmixtures.dark_text_disabled
        "
        [label]="
          texts()
            | filterTexts
              : ERelationType.personalDataBirthdate
              : EEntityType.generalArea
            | language
        "
        formControlName="dateOfBirth" />
    }
    <div class="flex flex-col gap-3 sm:flex-row sm:justify-end">
      @if (!isNewFellowTraveler()) {
        <aw-button
          [id]="'fellow-traveler-delete-' + travelerId()"
          type="button"
          [style]="'error-alt'"
          [isDisabled]="isSavingOrDeleting()"
          (click)="delete()">
          {{
            texts()
              | filterTexts
                : ERelationType.deleteFellowTravelerButtonText
                : EEntityType.privateArea
              | language
          }}
        </aw-button>
      }
      <aw-button
        [id]="'fellow-traveler-cancel-' + travelerId()"
        type="button"
        [style]="'primary-alt'"
        [isDisabled]="
          (!isNewFellowTraveler() && fellowTravelerForm.pristine) ||
          isSavingOrDeleting()
        "
        (click)="cancel()">
        {{
          texts()
            | filterTexts: ERelationType.cancel : EEntityType.generic
            | language
        }}
      </aw-button>
      <aw-button
        [id]="'fellow-traveler-save-' + travelerId()"
        type="submit"
        [isDisabled]="
          fellowTravelerForm.invalid ||
          fellowTravelerForm.pristine ||
          isSavingOrDeleting()
        ">
        {{
          texts()
            | filterTexts
              : ERelationType.saveButtonText
              : EEntityType.privateArea
            | language
        }}
      </aw-button>
    </div>
  </form>
</article>
